import { DateRangeState } from '@zonofi/zono-money-store';
import moment from 'moment';
import { DateRangeKeys, RelativeTimeRange } from '../../types';

export const DATE_RANGE_FILTERS: Record<DateRangeKeys, DateRangeState> = {
  [DateRangeKeys.Today]: {
    startDate: moment().startOf('day').toDate(),
    endDate: moment().endOf('day').toDate(),
  },
  [DateRangeKeys.Yesterday]: {
    startDate: moment().subtract(1, 'day').startOf('day').toDate(),
    endDate: moment().subtract(1, 'day').endOf('day').toDate(),
  },
  [DateRangeKeys.ThisWeek]: {
    startDate: moment().startOf('week').toDate(),
    endDate: moment().endOf('day').toDate(),
  },
  [DateRangeKeys.LastWeek]: {
    startDate: moment().subtract(1, 'week').startOf('week').toDate(),
    endDate: moment().subtract(1, 'week').endOf('week').toDate(),
  },
  [DateRangeKeys.ThisMonth]: {
    startDate: moment().startOf('month').toDate(),
    endDate: moment().endOf('day').toDate(),
  },
  [DateRangeKeys.Last3Months]: {
    startDate: moment().subtract(3, 'months').startOf('month').toDate(),
    endDate: moment().endOf('day').toDate(),
  },
};

export const RELATIVE_TIME_RANGE_FILTERS: Record<
  RelativeTimeRange,
  { key: RelativeTimeRange; label: string }
> = {
  LAST_24_HOURS: { key: 'LAST_24_HOURS', label: 'Last 24 Hours' },
  LAST_3_DAYS: { key: 'LAST_3_DAYS', label: 'Last 3 Days' },
  LAST_7_DAYS: { key: 'LAST_7_DAYS', label: 'Last 7 Days' },
  LAST_15_DAYS: { key: 'LAST_15_DAYS', label: 'Last 15 Days' },
  LAST_30_DAYS: { key: 'LAST_30_DAYS', label: 'Last 30 Days' },
  LAST_60_DAYS: { key: 'LAST_60_DAYS', label: 'Last 60 Days' },
};
